import React from "react";
import {
  FaBalanceScale,
  FaCoins,
  FaChartLine,
  FaShieldAlt,
  FaDesktop,
  FaWater,
} from "react-icons/fa";

function KeyFeatures() {
  return (
    <>
      <div
        className="process-style-two-area overflow-hidden bg-cover default-padding bg-dark text-light"
        style={{
          backgroundImage:
            "url(https://validthemes.net/site-template/robok/assets/img/shape/banner-20.jpg)",
        }}
      >
        <div className="container">
          <div className="site-heading">
            <div className="row align-center">
              <div className="col-lg-6">
                <h4 className="sub-title">Our Process</h4>
                <h2 className="title split-text-right split-text-in-right split-lines">
                  Key Features of Our Security Token Trading Exchange
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="process-style-two-items">
            <div className="row">
              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon pb-30 ">
                    <FaBalanceScale size={42} />
                  </div>
                  <h4>Regulatory Compliance</h4>
                  <p>
                    Ensure that your platform adheres to the necessary legal and
                    regulatory frameworks, allowing for seamless trading of
                    security tokens while protecting both issuers and investors.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon pb-30 ">
                    <FaCoins size={42} />
                  </div>
                  <h4>Tokenization Solutions</h4>
                  <p>
                    Providing comprehensive tokenization services, converting
                    physical assets into digital security tokens. This process
                    enhances liquidity and opens up investment opportunities to
                    a broader audience.
                  </p>
                  <br />
                </div>
              </div>

              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon pb-30 ">
                    <FaChartLine size={42} />
                  </div>
                  <h4>Advanced Trading Features</h4>
                  <p>
                    Integrating sophisticated trading tools, including order
                    types, real-time market data, and analytical tools, enabling
                    users to make informed trading decisions and optimize their
                    investment strategies.
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon pb-30 ">
                    <FaShieldAlt size={42} />
                  </div>
                  <h4>High Security Standards</h4>
                  <p>
                    Security is our top priority. We implement multi-signature
                    wallets, multi-level authentication, and high-level
                    encryption to protect user assets and sensitive information.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon pb-30 ">
                    <FaDesktop size={42} />
                  </div>
                  <h4>User-Friendly Interface</h4>
                  <p>
                    Designed with user experience in mind, providing an
                    intuitive interface that simplifies navigation and trading
                    for both novice and experienced investors.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon pb-30 ">
                    <FaWater size={42} />
                  </div>
                  <h4>Liquidity Management</h4>
                  <p>
                    We help establish liquidity pools to ensure that your
                    security token trading exchange maintains sufficient
                    liquidity for smooth transactions and market stability.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default KeyFeatures;
